export default {
    name: 'process-echarts',
    props: {
        id: {
            type: String,
            default: ''
        },
        data:{
            type:Array,
            default() {
                return [];
            }
        }
    },
    watch: {
        data: {
            deep: true,
            handler: function (val) {
                this.processData = val;
                // this.handleData();
            }
        }
    },
    data() {
        return {processData:this.data};
    },
    methods: {
        getWidth(value) {
            // 如果数字是0返回0
            if (!value) {
                return 'width:0px';
            }
            // 数据总长度
            const length = this.processData.length - 1;
            // 最大数据
            const maxVal = this.processData[0].value;
            // 最小数据
            const minVal = this.processData[length].value;
            // 中间部分的差值件数
            const proportionVal = maxVal - minVal;
            const maxWidth = 1200;
            const minWidth = 160;
            // 当前数值和差值的比例
            const proportion = (value - minVal) / proportionVal;
            // 宽度的差值
            const widthNum = maxWidth - minWidth;
            return `width:${widthNum * proportion + minWidth}px`;
        }
    }
};
